import Vue from "vue";
import ResourceService from "./resource.service";

class BillingService extends ResourceService {
  static get resource() {
    return "billing";
  }

  static previewBillingFile(payload) {
    const url = `${this.resource}/generate-billing-invoice`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, payload, {responseType: 'blob'})
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getBillingInvoiceReference(business_id) {
    const url = `${this.resource}/generate-billing-invoice`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url,{
          params: {
            business_id: business_id
          }
        })
        .then((data) => {
          resolve(data);
        });
    });
  }

  static generateBillingInvoice(payload) {
    const url = `${this.resource}/generate-billing-invoice`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, payload)
        .then((data) => {
          resolve({...data});
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


}

export default BillingService;
